import { DistributionType } from '../../domain/enums/distribution-type';

export class AddressItemViewModel {
    public addressId: string;
    public x: number;
    public y: number;
    public subAddresses: number;
    public streetName: string;
    public houseNumber: string;
    public postalCode: string;
    public city: string;
    public distributionType: DistributionType;
    public modifiedBy: string;
    public modifiedAt: Date;
    public visited: boolean;

    constructor();
    constructor(json: any);
    constructor(json?: AddressItemViewModel) {
        if (json) {
            this.addressId = json.addressId;
            this.x = json.x;
            this.y = json.y;
            this.subAddresses = json.subAddresses;
            this.streetName = json.streetName;
            this.houseNumber = json.houseNumber;
            this.postalCode = json.postalCode;
            this.city = json.city;
            this.distributionType = json.distributionType;
            this.modifiedBy = json.modifiedBy;
            this.modifiedAt = json.modifiedAt;
            this.visited = json.visited;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/view-models/address-item.view-model.ts